<template>
  <div class="card card-shadow">
    <div class="card-header">
      <h1 class="h4">{{ translate('previews.subtest-attempt.title', { role: role }) }}</h1>
    </div>
    <div class="card-body p-4">
      <div class="row">
        <div class="col-lg-12 text-center">
          <span style="font-size: 50px;" :class="userClass"></span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <ul style="list-style-type: none; padding-inline-start: 0" class="mb-0">
            <li>
              {{ translate('previews.user.info.name') }}: <span class="font-weight-bold">{{ user.name }}</span>
            </li>
            <li>
              {{ translate('previews.user.info.email') }}: <span class="font-weight-bold">{{ user.email }}</span>
            </li>
          </ul>
        </div>
      </div>

      <hr>

      <div class="row">
        <div class="col-md-12 mt-2">
          <button
            class="btn btn-block btn-primary text-white"
            @click="showEditUserModal">
            <span class="fa fa-user-edit mr-1"></span>{{ translate('previews.buttons.edit') }}
          </button>
        </div>

        <div class="col-md-12 mt-2">
          <button
            class="btn btn-block btn-danger text-white"
            @click="showDeleteUserModal">
            <span class="fa fa-user-times mr-1"></span>{{ translate('previews.buttons.delete') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['user', 'role'],

  data () {
    return {};
  },

  computed: {
    userClass () {
      if (this.role === 'supervisor') {
        return 'fa fa-user-shield text-muted';
      }

      if (this.role === 'reviewer') {
        return 'fa fa-chalkboard-teacher text-muted';
      }

      if (this.role === 'student') {
        return 'fa fa-graduation-cap text-muted';
      }

      return '';
    }
  },

  methods: {
    showEditUserModal () {
      this.$parent.$emit('showEditUserModal');
    },

    showDeleteUserModal () {
      this.$parent.$emit('showDeleteUserModal');
    }
  }
};
</script>
